import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import _ from 'lodash';

import Api from 'util/Api';
import Loader from 'components/Loader';
import SortableHeaderCell from 'components/SortableHeaderCell';

class PatientsIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            searchTerm: '',
            sortBy: 'lastName',
            sortAscending: true,
            patients: [],
        };

        this.handleChange = this.handleChange.bind(this);
        this.updateSort = this.updateSort.bind(this);
    }

    componentDidMount() {
        ['searchTerm', 'sortBy', 'sortAscending'].forEach((key) => {
            const val = sessionStorage.getItem(key);
            if (val) { this.setState({[key]: val}); }
        });

        Api.withAuth(this.props.auth).getPatientsWithRooms(this.props.match.params)
            .then((data) => {
                this.setState({
                    //patients: data.rooms,
                    patients: data,
                    isLoading: false,
                });
            });
    }

    componentWillUnmount() {
        ['searchTerm', 'sortBy', 'sortAscending'].forEach((key) => {
            if (this.state[key]) { sessionStorage.setItem(key, this.state[key]); }
        });
    }

    handleChange({target}) {
        this.setState({
            [target.name]: target.value
        });
    }

    updateSort(field) {
        let {sortAscending} = this.state;

        if (field === this.state.sortBy) { sortAscending = !sortAscending; } else { sortAscending = true; }

        this.setState({
            sortAscending,
            sortBy: field,
        });
    }

    render() {
        const {patients, searchTerm} = this.state;
        const {auth, match} = this.props;
        let filteredPatients = _(patients)
            .map((patient) => ({
                ...patient,
                searchField: (patient.patient_name) ? patient.patient_name.toLowerCase() : ""
                    .concat((patient.room_name) ? patient.room_name.toLowerCase() : "")
            }))
            // .filter((items) => !_.isEmpty(items.patient))
            .filter(({searchField}) => (_.isEmpty(searchTerm) ? true : searchField.includes(searchTerm.toLowerCase())))
            .sortBy(this.state.sortBy)
            .value();

        filteredPatients = this.state.sortAscending ? filteredPatients : _.reverse(filteredPatients);

        return (
            <div className='patient-list'>
                <div className='subnav fixed-top'>
                    <div className='container h-100'>
                        <div className='row d-flex align-items-center h-100'>
                            <h3>Residents</h3>

                            { _.indexOf(auth.currentUser.roles, 'user') === -1 &&
                                (<div className='ml-auto actions'>
                                    <Link to={`/facilities/${match.params.facility}/sections/${match.params.section}/patients/new`}>
                                        <span className='callout'>New Resident</span>
                                    </Link>
                                </div>)
                            }
                        </div>
                    </div>
                </div>

                {_.get(this.props, 'location.state.message') &&
          <div className='alert alert-info '>{this.props.location.state.message}</div>
                }

                <div className='row'>
                    <div className='col-md-12'>
                        <div className='patient-list-container row'>
                            {this.state.isLoading ? (
                                <Loader />
                            ) : (
                                <div className='col-md-12 row'>
                                    <div className='search-actions d-flex col-md-6'>
                                        <input
                                            type='text'
                                            className='form-control'
                                            name='searchTerm'
                                            placeholder='First Name, Last Name, or Room Number'
                                            value={searchTerm}
                                            onChange={this.handleChange} />
                                        <button
                                            className='btn btn-outline-secondary'
                                            onClick={() => this.setState({searchTerm: ''})}
                                            disabled={!searchTerm} >
                                            Clear
                                        </button>
                                    </div>
                                    <div className='patient-list-summary col-md-12'>
                                        Displaying <strong>{filteredPatients.length}</strong> of {patients.length} residents.
                                    </div>
                                    <div className='patient-table col-md-12'>
                                        <table className='table table-hover table-sm'>
                                            <thead>
                                                <tr>
                                                    <SortableHeaderCell value='patient_name' sortBy={this.state.sortBy} sortAscending={this.state.sortAscending} onClick={this.updateSort} >Patient Name</SortableHeaderCell>
                                                    <SortableHeaderCell value='roomDetails.name' sortBy={this.state.sortBy} sortAscending={this.state.sortAscending} onClick={this.updateSort} >Room/Bed No.</SortableHeaderCell>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredPatients.map((patient) => (
                                                    <tr key={patient.id} onClick={() => this.props.history.push(`patients/${patient.id}/edit`)}>
                                                        <td>{patient.patient_name }</td>
                                                        <td>{patient.bed_name ? patient.room_name + ' / ' + patient.bed_name : patient.room_name}</td>
                                                    </tr>
                                                    /*<tr key={patient.patient_id} onClick={() => this.props.history.push(`patients/${patient.patient_id}/edit`)}>
                                                        <td>{patient.patient_name}</td>
                                                        <td>{patient.room_name}</td>
                                                    </tr>*/
                                                ))}
                                            </tbody>
                                        </table>

                                        {filteredPatients.length === 0 && patients.length !== 0 &&
                                          <div className='no-results'>
                                            No Results Found
                                          </div>
                                        }
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PatientsIndex;
